import classNames from "classnames";
import React, { memo } from "react";
import ButtonWithTooltip from "../buttonWithTooltip";
import locale from "./redoButton.locale";
import { Button } from "UiKit";
function RedoButton(props) {
    return props.useNewBtn ? (React.createElement(Button, { styleType: "text", size: "32", disabled: props.disabled, onClick: props.onRedo, tooltipMessage: locale.REDO, iconOnly: true, elementAttr: props.elementAttr },
        React.createElement("i", { className: "icon-redo" }))) : (React.createElement(ButtonWithTooltip, { width: props.btnSize, height: props.btnSize, className: classNames("no-border", props.className), disabled: props.disabled, onClick: props.onRedo, popoverContent: locale.REDO, elementAttr: props.elementAttr },
        React.createElement("i", { className: "icon-redo" })));
}
export default memo(RedoButton);
RedoButton.defaultProps = {
    btnSize: 28
};
